import React, {Component, useCallback, useState} from "react";
import moment from "moment";
import 'moment/locale/tr';
import generateFakeData from "./react-calendar-timeline/generate-fake-data";
import Timeline, {DateHeader, SidebarHeader, TimelineHeaders,CursorMarker, CustomHeader, CustomMarker, TimelineMarkers, TodayMarker} from 'react-calendar-timeline/lib';
import "react-calendar-timeline/lib/Timeline.css";

import TaskListPopup from "./TaskListPopup";
import axios from "axios";
import { api } from "./api/client";
import debounce from "lodash.debounce";



moment().locale('tr');


let keys = {
    groupIdKey: "id",
    groupTitleKey: "title",
    groupRightTitleKey: "rightTitle",
    itemIdKey: "id",
    itemTitleKey: "title",
    itemDivTitleKey: "title",
    itemGroupKey: "group",
    itemTimeStartKey: "start",
    itemTimeEndKey: "end",
    groupLabelKey: "title"
};
const Legend = () => {
    const legendStyles = {
        legend: {
            display: "flex",
            gap: "5px",
            alignItems: "center",
            fontSize: "10px",
        },
        legendItem: {
            display: "flex",
            alignItems: "center",
            gap: "5px",
        },
        box: {
            width: "10px",
            height: "10px",
            border: "1px solid #000",
        },
        colors: {
            orange: { backgroundColor: 'rgb(255,118,0)' },
            lightGreen: { backgroundColor: "rgba(105,252,60,0.6)" },
            darkGreen: { backgroundColor: "rgba(0,100,0,0.6)" },
            gray: { backgroundColor: "gray" },
            blue: { backgroundColor: "rgba(73,73,255,0.6)" },

        },
    };

    return (
        <div style={legendStyles.legend}>
            <div style={legendStyles.legendItem}>
                <div style={{...legendStyles.box, ...legendStyles.colors.orange}}></div>
                <span>Avrupa</span>
            </div>
            <div style={legendStyles.legendItem}>
                <div
                    style={{...legendStyles.box, ...legendStyles.colors.lightGreen}}
                ></div>
                <span>Türkiye</span>
            </div>
            <div style={legendStyles.legendItem}>
                <div
                    style={{...legendStyles.box, ...legendStyles.colors.darkGreen}}
                ></div>
                <span>ABD</span>
            </div>
            <div style={legendStyles.legendItem}>
                <div style={{...legendStyles.box, ...legendStyles.colors.blue}}></div>
                <span>İzin</span>
            </div>
            <div style={legendStyles.legendItem}>
                <div style={{...legendStyles.box, ...legendStyles.colors.gray}}></div>
                <span>Taslak</span>
            </div>
        </div>
    );
};

export default function TaskTableGeneral() {

    const [groups, setGroups] = useState([]);
    const [openGroups, setOpenGroups] = useState({});
    const [items, setItems] = useState([]);
     let [defaultTimeStart, setDefaultTimeStart] = useState(moment()
        .startOf("month").subtract(15, "days")
        .toDate());
    let [defaultTimeEnd, setDefaultTimeEnd] = useState(moment()
        .startOf("month")
        .add(1, "month")
        .toDate());
    const [visibleTimeStart, setVisibleTimeStart] = useState(moment()
        .startOf("week")
        .valueOf());
    const [visibleTimeEnd, setVisibleTimeEnd] = useState(moment()
        .startOf("month")
        .add("1", "month")
        .valueOf());
    const [showModal, setShowModal] = useState(false);
    const [unit, setUnit] = useState('month');
    const [draggedItem, setDraggedItem] = useState('month');
    const defaultVisableTimeEnd = moment().add(24, 'hour')


    const generateGroupId = (d, index) => {
        if (d.isim && d.soyisim) {
            return `${d.isim} ${d.soyisim}`;
        }
        return `group-${index}`; // Fallback ID
    };

    const getDataz = async () => {

        const res = await api.get('/lookups/users', { params: { limit: 2000, scope: 'takvim' } })
        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        //console.log('ne bunlar',data);
        let groupz = data.map((d, index) => ({
             id: d.id ?? generateGroupId(d, index),
            title: d.root ? (d.title || d.isim) : generateGroupId(d, index),
            "root":d.root,
            "vize_tarihi":"test",
            "group":index
        }))
        setGroups(groupz)
    };

/*
    const getTimeLineDataz = async (start, end) => {
        try {
            // Başlangıç ve bitiş tarihlerini formatla
            const formattedStart = moment(start).format("YYYY-MM-DD");
            const formattedEnd = moment(end).format("YYYY-MM-DD");

            // API çağrısı
            const res = await api.get('/timeline', {
                    params: { start: formattedStart, end: formattedEnd },
                });

            const data = res.data;
            let itemz = []; // Görev listesi
            let no=0
            // Gelen verileri işleyip formatla
            data.forEach((d, index) => {
                // Görev rengini belirleme
                const bgColor =
                    d.izin == "1"
                        ? "rgba(73,73,255,0.6)"
                        : d.durum === "Taslak"
                            ? "rgba(111,112,111,0.6)"
                            : d.bolge === "Türkiye"
                                ? "rgba(105,252,60,0.6)"
                                : d.bolge === "Amerika"
                                    ? "rgba(25,61,13,0.6)"
                                    : d.bolge === "Avrupa"
                                        ? "rgb(255,118,0)"
                                        : d.dil === "Türkçe"
                                            ? "rgba(105,252,60,0.6)"
                                            : "rgba(25,61,13,0.6)";

                // Görev nesnesini oluştur
                const its = {
                    id: no++ , // Benzersiz bir id
                    group: d.group_id || d.id || `task-${index}`, // personel id
                    firma: d.musteri,
                    lokasyon: d.lokasyon,
                    uyfler: d.uyfler,
                    makineler: d.makineler,
                    is_emri_no: d.is_emri_no,
                    personeller: d.personeller,
                    ilgili_kisi: d.ilgili_kisi,
                    ilgili_kisi_telefon: d.ilgili_kisi_telefon,
                    ilgili_kisi_eposta: d.ilgili_kisi_eposta,
                    lokasyon_adresi: d.lokasyon_adresi,
                    is_emri_baslangic_tarihi: d.is_emri_baslangic_tarihi,
                    is_emri_bitis_tarihi: d.is_emri_bitis_tarihi,
                    sebep: d.sebep,
                    bolge: d.bolge,
                    start: moment(d.is_emri_tarihi + " " + (d.start || d.is_emri_baslangic_saati || "08:00:00")).valueOf(),
                    end: moment(d.is_emri_tarihi + " " + (d.end || d.is_emri_bitis_saati || "18:00:00")).valueOf(),
                    canMove: false, // Hareket ettirilebilirlik
                    canResize: false, // Yeniden boyutlandırılabilirlik
                    itemProps: {
                        // Özelleştirilmiş stiller
                        "aria-hidden": true,
                        onDoubleClick: () => {
                            console.log(`Double clicked: ${d.is_emri_no}`);
                        },
                        className: "weekend",
                        style: {
                            background: "orange",
                        },
                    },
                    selectedBgColor: "#f60", // Seçildiğinde arka plan rengi
                    bgColor: bgColor, // Görev rengini ayarla
                };

                itemz.push(its); // Görev listesini güncelle
            });

//            console.log("İş emirleri:", itemz);
            setItems(itemz); // React state'e yeni verileri ekle
        } catch (error) {
            console.error("Veri çekilirken hata oluştu:", error);
        }
    }; */
    const getTimeLineDataz = async (start, end) => {
        try {
            // Başlangıç ve bitiş tarihlerini formatla
            const formattedStart = moment(start).format("YYYY-MM-DD");
            const formattedEnd = moment(end).format("YYYY-MM-DD");

            // API çağrısı
            const res = await api.get('/timeline', {
                    params: { start: formattedStart, end: formattedEnd },
                });

            const data = res.data;

            // Veriler boşsa varsayılan grup ve öğeleri oluştur
            if (data.length === 0) {

                setItems([
                    {
                        id: "default-item",
                        group: "default-group",
                        title: "Bu tarihlerde görev yok",
                        start: moment(start).valueOf(),
                        end: moment(end).valueOf(),
                        canMove: false,
                        canResize: false,
                        itemProps: {
                            style: {
                                backgroundColor: "rgba(200, 200, 200, 0.5)",
                            },
                        },
                    },
                ]);
                return;
            }

            // Gelen verileri işleyip formatla
            let itemz = [];
            let no = 0;

            data.forEach((d, index) => {
                const bgColor =
                    d.izin == "1"
                        ? "rgba(73,73,255,0.6)"
                        : d.durum === "Taslak"
                            ? "rgba(111,112,111,0.6)"
                            : d.bolge === "Türkiye"
                                ? "rgba(105,252,60,0.6)"
                                : d.bolge === "Amerika"
                                    ? "rgba(25,61,13,0.6)"
                                    : d.bolge === "Avrupa"
                                        ? "rgb(255,118,0)"
                                        : d.dil === "Türkçe"
                                            ? "rgba(105,252,60,0.6)"
                                            : "rgba(25,61,13,0.6)";

                const its = {
                    id: no++ , // Benzersiz bir id
                    group: d.group_id || d.id || `task-${index}`, // personel id
                    firma: d.musteri,
                    lokasyon: d.lokasyon,
                    uyfler: d.uyfler,
                    makineler: d.makineler,
                    is_emri_no: d.is_emri_no,
                    personeller: d.personeller,
                    ilgili_kisi: d.ilgili_kisi,
                    ilgili_kisi_telefon: d.ilgili_kisi_telefon,
                    ilgili_kisi_eposta: d.ilgili_kisi_eposta,
                    lokasyon_adresi: d.lokasyon_adresi,
                    is_emri_baslangic_tarihi: d.is_emri_baslangic_tarihi,
                    is_emri_bitis_tarihi: d.is_emri_bitis_tarihi,
                    sebep: d.sebep,
                    bolge: d.bolge,
                    start: moment(d.is_emri_tarihi + " " + (d.start || d.is_emri_baslangic_saati || "08:00:00")).valueOf(),
                    end: moment(d.is_emri_tarihi + " " + (d.end || d.is_emri_bitis_saati || "18:00:00")).valueOf(),
                    canMove: false, // Hareket ettirilebilirlik
                    canResize: false, // Yeniden boyutlandırılabilirlik
                    itemProps: {
                        // Özelleştirilmiş stiller
                        "aria-hidden": true,
                        onDoubleClick: () => {
                            console.log(`Double clicked: ${d.is_emri_no}`);
                        },
                        className: "weekend",
                        style: {
                            background: "orange",
                        },
                    },
                    selectedBgColor: "#f60", // Seçildiğinde arka plan rengi
                    bgColor: bgColor, // Görev rengini ayarla
                };

                itemz.push(its); // Görev listesini güncelle

             });


            setItems(itemz);
        } catch (error) {
            console.error("Veri çekilirken hata oluştu:", error);
        }
    };

  useState(()=>{
      getTimeLineDataz(defaultTimeStart,defaultTimeEnd) ;
      getDataz();
  },[])

    const handleDoubleClick = (group, time, e) => {
        console.log('handleDoubleClick', group, time, e)
         //setOpenModal(true})
        /*var newItems = [...this.state.items, {
            id: this.state.items.length+1,
            group: group,
            title: '3',
            start: moment(time).startOf('day').valueOf(),
            end: moment(time).startOf('day').valueOf() + 1 * 24 * 60 * 60 * 1000,
            canResize: 'both',
            // canMove: startValue > new Date().getTime(),
            // canResize: startValue > new Date().getTime() ? (endValue > new Date().getTime() ? 'both' : 'left') : (endValue > new Date().getTime() ? 'right' : false),
            //className: 'item-weekend',
            itemProps: {
            }
        }]/
        this.setState({
            items: newItems
        })*/
    }




    //nex,prev, date filter buttons

    const onPrevClick = () => {
        if (unit === "week") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(-1, "week")
                .startOf("week")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(-1, "week")
                .endOf("week")
                .valueOf();

                setVisibleTimeStart(newVisibleTimeStart);
                setVisibleTimeEnd(newVisibleTimeEnd);

        }
        if (unit === "month") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(-1, "month")
                .startOf("month")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(-1, "month")
                .endOf("month")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
        if (unit === "year") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(-1, "year")
                .startOf("year")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(-1, "year")
                .endOf("year")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
    };

    const onNextClick = () => {
        if (unit === "week") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(1, "week")
                .startOf("week")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(1, "week")
                .endOf("week")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
        if (unit === "month") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(1, "month")
                .startOf("month")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(1, "month")
                .endOf("month")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
        if (unit === "year") {
            let newVisibleTimeStart = moment(visibleTimeStart)
                .add(1, "year")
                .startOf("year")
                .valueOf();
            let newVisibleTimeEnd = moment(visibleTimeStart)
                .add(1, "year")
                .endOf("year")
                .valueOf();
            setVisibleTimeStart(newVisibleTimeStart);
            setVisibleTimeEnd(newVisibleTimeEnd);
        }
    };
    const debouncedFetchData = useCallback(debounce(getTimeLineDataz, 300), []);

    // onTimeChange Event Handler
    const handleTimeChange = (start, end, updateScrollCanvas) => {
        setVisibleTimeStart(start);
        setVisibleTimeEnd(end);
        debouncedFetchData(start, end); // API'den veri getir
        updateScrollCanvas(start, end); // Çizelgeyi güncelle

    };

    const handleTimeHeaderChange = unit => {
         setUnit(unit);
        if (unit === "week") {
            setVisibleTimeStart(moment()
                    .startOf("week")
                    .valueOf());
            setVisibleTimeEnd(moment()
                    .endOf("week")
                    .valueOf());
        }
        if (unit === "month") {
            setVisibleTimeStart(moment()
                .startOf("month")
                .valueOf());
            setVisibleTimeEnd(moment()
                .endOf("month")
                .valueOf());
        }
        if (unit === "year") {
            setVisibleTimeStart(moment()
                .startOf("year")
                .valueOf());
            setVisibleTimeEnd(moment()
                .endOf("year")
                .valueOf());
        }
    };
    const newGroups = groups
        .map(group => {
            return Object.assign({}, group, {
                title: group.root ? (
                    <div style={{margin:0,padding:0 ,paddingLeft:10,backgroundColor:'#ccc', fontSize:'14px', fontWeight:'bold'}}>{group.title }</div>
                ) : (
                    <div style={{ padding: 0,paddingLeft:10,fontSize:'14px' }}>{group.title} </div>
                )
            });
        });


    const openInNewTab = (personal,personalId,time) => {
        let date= moment(time).format('YYYY-MM-DD')
        let url = '/talep-ekle?personal='+personal+'&personalId='+personalId+'&date='+date;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    //console.log('newfgoro',newGroups);
    //custom item
    const itemRenderer = ({item, timelineContext, itemContext, getItemProps, getResizeProps}) => {
        const {left: leftResizeProps, right: rightResizeProps} = getResizeProps();
        const backgroundColor = itemContext.selected ? (itemContext.dragging ? "blue" : item.selectedBgColor) : item.bgColor;
        const borderColor = itemContext.resizing ? "blue" : item.color;
        return (
            <div
                {...getItemProps({
                    style: {
                        backgroundColor,
                        color: item.color,
                        borderRadius: 4,
                        borderLeftWidth: itemContext.selected ? 3 : 1,
                        borderRightWidth: itemContext.selected ? 3 : 1,
                        transform : 'scaleX(0.5)',
                        ransformOrigin : 'bottom',
                        padding:0,
                        height:itemContext.dimensions.height/3,
                        border: itemContext.selected ? 'dashed 1px rgba(0,0,0,0.3)' : 'none',
                         boxShadow: `0 1px 5px 0 rgba(0, 0, 0, 0.2),
                     0 2px 2px 0 rgba(0, 0, 0, 0.14),
                     0 3px 1px -2px rgba(0, 0, 0, 0.12)`
                    },
                    onDoubleClick: () => { console.log('You clicked double!') },

                })}
            >
                <div
                    style={{

                        overflow: "hidden",
                        paddingLeft: 0,
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >

                    <TaskListPopup  itemC={item}/>
                </div>
            </div>
        );
    };

    const defaultTimeRange = defaultTimeEnd - defaultTimeStart;

    return (
        <>
            <div>İş Emirleri Takvimi    </div>
            <div>

                {
                    groups.length != 0 && items.length != 0 && <Timeline
                        ranges={[{
                            id: 5959595,
                            start_time: moment().toDate(),
                            end_time: moment().add(3, 'day').toDate(),
                            className: 'weekend'
                        }]}
                        groups={newGroups}
                        items={items}
                keys={keys}
                sidebarWidth={250}
                itemTouchSendsClick={false}
                stackItems={true}
                itemHeightRatio={0.5}
                lineHeigth={35}
                defaultTimeStart={defaultTimeStart}
                defaultTimeEnd={defaultTimeEnd}
                minZoom={defaultTimeRange}
                maxZoom={defaultTimeRange}
                itemRenderer={itemRenderer}
                    onTimeChange={handleTimeChange}
                onItemClick={() => {
                    return false
                }}

                fixedHeader='fixed'
                fullUpdate={true}
                >
                <TimelineHeaders className="sticky">
                    <SidebarHeader >
                        {({ getRootProps }) => {
                            return <div {...getRootProps()}> <br/><p><Legend/></p>
                            </div>
                        }}

                    </SidebarHeader>
                    <DateHeader style={{backgroundColor: '#f60'}} unit="month" />
                    <DateHeader unit="week" />
                    <DateHeader labelFormat="dd DD"/>
                </TimelineHeaders>
                <TimelineMarkers>

                <TodayMarker >
                </TodayMarker>
                    <CustomMarker date={moment(new Date())}>
                        {/* custom renderer for this marker */}
                        {({ styles, date }) => {
                            const customStyles = {
                                ...styles,
                                backgroundColor: 'blue',
                                width: '2px'
                            }
                            return <div style={customStyles}   />
                        }}
                    </CustomMarker>
                <CursorMarker />
            </TimelineMarkers>
        </Timeline> }
            { /*draggedItem && (
                <InfoLabel
                    item={draggedItem.item}
                    group={draggedItem.group}
                    time={draggedItem.time}
                />
            ) */}
        </div></>
    );

}
